import React from 'react'
import { Draggable } from '@hello-pangea/dnd'
import classNames from 'classnames'
import Icon from '../../shared/icon'

const operationIcons = {
  set_stove_level: 'thermometer',
  set_cooking_mode: 'settings',
  unload_boiler: 'unload',
  wash_tray: 'shower',
}

interface Operation {
  operation: string,
  name: string,
}

interface OperationItemProps extends Operation {
  isPlaceholder?: boolean,
  isDragging?: boolean,
}

const DraggableOperation = ({ index, ...operation }) => {
  return (
    <Draggable draggableId={JSON.stringify(operation)} index={index}>
      {(provided, snapshot) =>
        <>
          <div
            className={`draggable-operation ${snapshot.isDragging ? 'dragging' : ''}`}
            data-operation={operation.operation}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <OperationItem {...operation as Operation} isDragging={snapshot.isDragging} />
          </div>
          {snapshot.isDragging &&
            <OperationItem {...operation as Operation} isPlaceholder={true} />
          }
        </>
      }
    </Draggable>
  )
}

const OperationItem: React.FC<OperationItemProps> = ({
  operation, name, isPlaceholder, isDragging
}) => {

  const operationClassNames = classNames(
    'operation-container',
    {
      'placeholder': isPlaceholder,
    }
  )

  return (
    <div className={operationClassNames}>
        <div className={`operation ${isDragging ? 'dragging' : ''}`}>
          <Icon name={operationIcons[operation]} className='operation-icon' color='#fff' />
        </div>
      { !isDragging && <div className='operation-name'>{name}</div> }
    </div>
  )
}

export { operationIcons }
export default DraggableOperation
